import { render } from "./DownloadSection.vue?vue&type=template&id=65550c6e&scoped=true"
import script from "./DownloadSection.vue?vue&type=script&lang=js"
export * from "./DownloadSection.vue?vue&type=script&lang=js"

import "./DownloadSection.vue?vue&type=style&index=0&id=65550c6e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65550c6e"]])

export default __exports__